import { getConfig } from 'helpers/config';
import { logRequestError } from 'services/analytics/log-request-error';
import { getAccessToken } from 'services/auth/auth-storage-manager';

import { createApiClient } from '../http/client';
import { type ApiClientInstance } from '../http/types';

export const createGlobalAccountsApiClient = (): ApiClientInstance => {
  return createApiClient({
    baseURL: getConfig().accounts,
    getCredentials: getAccessToken,
    prefix: 'v2',
    onError: logRequestError,
  });
};
